import { User, LoginRequest, CreateUserRequest } from '../types';
import { apiClient, ApiError } from './apiClient';

interface Session {
    session_id: string;
    user_id: number;
    created_at: string;
    expires_at: string;
}

interface LoginResponse {
    user: User;
    session: Session;
}

const convertUserResponse = (user: any): User => ({
    id: user.id,
    email: user.email,
    createdAt: user.createdAt,
    updatedAt: user.updatedAt,
});

export const authApi = {
    async login(credentials: LoginRequest): Promise<LoginResponse> {
        try {
            const response = await apiClient.post<LoginResponse>('/api/users/login', credentials);

            if (!response) {
                throw new ApiError(401, 'Invalid credentials');
            }

            return {
                user: convertUserResponse(response.user),
                session: response.session
            };
        } catch (error) {
            if (error instanceof ApiError) {
                throw error;
            }
            throw new ApiError(401, 'Login failed');
        }
    },

    async register(userData: CreateUserRequest): Promise<User> {
        try {
            const response = await apiClient.post<User>('/api/users', userData);

            if (!response) {
                throw new ApiError(400, 'Registration failed');
            }

            return convertUserResponse(response);
        } catch (error) {
            if (error instanceof ApiError) {
                throw error;
            }
            throw new ApiError(400, 'Registration failed');
        }
    },

    async logout(): Promise<void> {
        try {
            await apiClient.post<void>('/api/users/logout', {});
        } catch (error) {
            if (error instanceof ApiError) {
                throw error;
            }
            throw new ApiError(500, 'Logout failed');
        }
    },

    async loginWithGoogle(idToken: string): Promise<LoginResponse> {
        try {
            const response = await apiClient.post<LoginResponse>('/api/users/google', { idToken });

            if (!response) {
                throw new ApiError(401, 'Google authentication failed');
            }

            return {
                user: convertUserResponse(response.user),
                session: response.session
            };
        } catch (error) {
            if (error instanceof ApiError) {
                throw error;
            }
            throw new ApiError(401, 'Google login failed');
        }
    },
};
